import React from 'react'
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function ViewTrendProduct({ product, show, onHide }) {
    const handleClose = () => onHide();

    return (
        <>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-12">
                            <Form.Label className='mb-0'>Product Image</Form.Label>
                            <div className="d-flex flex-wrap gap-3 mt-3">
                                {product.productImage && product.productImage.length > 0 ? (
                                    product.productImage.map((image, index) => (
                                        <div key={index} className="rounded-3 overflow-hidden" style={{ width: '150px', height: '150px' }}>
                                            <img
                                                src={`${process.env.REACT_APP_BACKEND_URL}/${image}`}
                                                alt={`Product ${index + 1}`}
                                                className="w-100 h-100 object-fit-cover"
                                            />
                                        </div>
                                    ))
                                ) : (
                                    <div className="rounded-3 overflow-hidden" style={{ width: '150px', height: '150px' }}>
                                        <img
                                            src="https://img.freepik.com/premium-photo/adult-beautiful-woman-working-out-light-background_470178-19669.jpg"
                                            alt="Default"
                                            className="w-100 h-100 object-fit-cover"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Title</Form.Label>
                            <p>{product.name ? product.name : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Original Price</Form.Label>
                            <p>{product.price ? `$ ${product.price}` : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Discount</Form.Label>
                            <p>{product.discount ? `$ ${product.discount}` : "-"}</p>
                        </div>

                        <div className="col-12">
                            <Form.Label className='mb-0'>Created Date</Form.Label>
                            <p>{product.createdAt ? new Date(product.createdAt).toISOString().split('T')[0] : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Link</Form.Label><br />
                            <a href={product.link ? product.link : "#"} target="_blank" rel="noopener noreferrer" className='text-primary'>{product.link ? product.link : "-"}</a>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewTrendProduct